<template>
  <div class="MOBILE-NEW-HEADER" >
    <div class="d-flex bg-black ">
      <div
          v-for="(link, mIndex) in $options.LINKS.sub"
          :key="mIndex"
          class="MOBILE-LINK-ITEM flex-1-0">
        <router-link
            v-if="link.isRoute"
            :to="{
              name: link.name,
              params: {
                jobsStatusAlias: $options.JOBS_STATUS_ALIASES.new.key,
                activePerformanceTab: $options.PERFORMANCE_TAB_NAMES.summary.key,
                activeNotificationTab: $options.NOTIFICATION_TAB_NAMES.updates.key,
              },
            }"
            class="MOBILE-LINK-LABEL TEXT text-capitalize"
            :class="{
              'router-link-active': $route.name === link.name,
              'NEW-MESSAGES': unreadMessages && link.name === 'dashboard::pro::messages'
            }"
            :selenium="`header-${link.label}-link`">
          {{link.label}}
        </router-link>
      </div>
      <transition name="fade-up" >
        <div class="MOBILE-ACCOUNT-MENU"  @click="close()"  v-if="isOpen">
          <div class="MENU-HEADER"> <vk-icon name="close" class="m-r-2 m-t-3" size="20"/></div>
          <div
              v-for="(link, mIndex) in $options.LINKS.main"
              :key="mIndex"
              class="w-100">
            <router-link
                v-if="link.isRoute"
                :to="{
                  name: link.name,
                  params: {
                    jobsStatusAlias: $options.JOBS_STATUS_ALIASES.new.key,
                    activePerformanceTab: $options.PERFORMANCE_TAB_NAMES.summary.key,
                    activeNotificationTab: $options.NOTIFICATION_TAB_NAMES.updates.key,
                  },
                }"
                class="MOBILE-ACCOUNT-ITEM d-flex c-gray80 ai-center w-100"
                :class="{'c-depot': $route.name === link.name}"
                :selenium="`header-${link.label}-link`">
              <div>
                <vk-icon
                    :name="link.icon"
                    class="m-r-2 m-t-3"
                    :size="link.size? link.size:18"
                    :class="{
                      'WHATS-NEW': showWhatsNew && link.name === 'dashboard::pro::notifications'
                }"/>
                {{link.label}}
              </div>
              <div v-if="link.new" class="NEW-PILL">New</div>
            </router-link>
            <div v-else class="MOBILE-ACCOUNT-ITEM" @click="nonRouteClick(link)">
              <vk-icon
                  :name="link.icon"
                  class="m-r-2 m-t-3"
                  :size="link.size? link.size:18" />
              <span> {{link.label}} </span>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isBefore } from 'date-fns';
import jobParams from '@/mixins/job-params';
import HeaderMenuChevron from '@/layouts/components/HeaderMenuChevron';
import { PERFORMANCE_TAB_NAMES } from '@/constants/performance-tab-names';
import { NOTIFICATION_TAB_NAMES } from '@/constants/notification-tab-names';
import LINKS from './links-constant';

export default {
  PERFORMANCE_TAB_NAMES,
  NOTIFICATION_TAB_NAMES,
  LINKS,
  name: 'mobile-nav-header',
  components: {
    HeaderMenuChevron,
  },
  mixins: [
    jobParams,
  ],
  provide () {
    return {
      $menu: this.$data,
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      dateOfLastUpate: null,
    };
  },
  computed: {
    ...mapGetters('prohub/whatsNew', ['groupedWhatsNewItems', 'timeUpdateSeen']),
    ...mapGetters('account/pro/inbox', ['hasUnreadMessages']),
    showWhatsNew () {
      if (this.timeUpdateSeen) {
        return isBefore(new Date(this.timeUpdateSeen), new Date(this.dateOfLastUpate));
      }
      return true;
    },
    unreadMessages () {
      return this.hasUnreadMessages;
    },
  },
  watch: {
    groupedWhatsNewItems (val) {
      this.dateOfLastUpate = val.latest[0].date;
    },
  },
  methods: {
    nonRouteClick (route) {
      this.close();
      this.$emit('on-none-route-menu', route);
    },
    close () {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
@keyframes wiggle {
  0%   { transform: translateY(0px) rotate(0deg); }
  80%  { transform: translateY(0px) rotate(0deg); }
  82%  { transform: translateY(-10px) rotate(-5deg); }
  85%  { transform: translateY(-10px) rotate(5deg); }
  87%  { transform: translateY(-10px) rotate(-5deg); }
  90%  { transform: translateY(-10px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}

.MOBILE-NEW-HEADER {

    .TEXT {
        color: #FFFFFF;
        font-size: 16px !important;
        font-weight:400 !important;
    }
    .MOBILE-LINK-LABEL {
        padding: 1.6*$unit 1*$unit 1*$unit;
        display: block;
        text-transform: capitalize;
        cursor: pointer;
    }
    .ACTIVE-ACCOUNT,
    .router-link-active {
        color: $color-depot;
        border-bottom: 5px solid $color-depot;
    }
      overflow-x: scroll;
}
.MOBILE-LINK-ITEM {
  text-align: center;
  width: 33%;
}
.MOBILE-ACCOUNT-MENU {
  position: absolute;
  width: 100%;
  border-right: 10vw solid  $color-gray70;
  height: 100vh;
  box-shadow: 0 8px 6px -6px rgba(black, 0.30);
  background-color: #fff;
  z-index: 100;
  .MOBILE-ACCOUNT-ITEM {
    display: block;
    padding: 1*$unit 10%;
    width: 100%;
  }
  .router-link-active {
    color: #222;
    border-bottom: 0;
  }
}
.WHATS-NEW {
  position: relative;
  animation: wiggle 3.0s infinite;
}
.NEW-PILL {
  background-color: $color-depot !important;
  color: white !important;
  margin-left: 4px;
  padding: 0px 4px;
  border-radius: 90px;
  font-size: 8px;
  font-weight: 400;
}
.MENU-HEADER {
  height: 60px;
  display: flex;
  justify-content: end;
}
.NEW-MESSAGES{
  &:after {
    content: '';
    background-color: $color-depot;
    @include circle(8px);
    position: absolute;
  }
}
</style>
